import dynamic from 'next/dynamic';
import A from './components/A';
// import css from './index.module.scss';
import B from './components/B';
import NA1 from './components/NA1';
import CardA from './newcomp/CardA';
import CardB from './newcomp/CardB';
import CardC from './newcomp/CardC';
import CardD from './newcomp/CardD';
import BannerA from './newcomp/BannerA';
import { useGlobal } from '@/utils/useGlobal';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexDynamic'), {
    ssr: true,
});

export default function ProductDetail({ freeQuote, freeQuoteBack }: any) {
    const { useEffect } = useGlobal();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && window.AniContainer) {
            return () => AniContainer.destroy();
        }
    }, []);

    return (
        <div className={`dpu-launch-detail`}>
            <NA1 />
            <div className="daily-use-spec"></div>
            <CardD />
            <div className="daily-use-spec"></div>
            <BannerA />
            <div className="daily-use-spec"></div>
            <CardC />
            <div className="daily-use-spec"></div>
            <CardA />
            <B />
            <div className="daily-use-spec"></div>
            <CardB />
            {/* <C /> */}
            {/* <IndexDynamic freeQuote={freeQuote} freeQuoteBack={freeQuoteBack} /> */}
            <style jsx global>
                {`
                    .footer {
                        background-color: #1f1f1f !important;
                        border-top-color: #343434 !important;
                    }
                    .footer-annotation {
                        background-color: #1f1f1f !important;
                    }
                `}
            </style>
        </div>
    );
}
